import React from "react";
import WinnerSelection from './WinnerSelection';
import StartCountdown from "./StartCountdown";
import TweetPromote from "./TweetPromote";

const ButtonGroup = ({
    openAnimation,
    openCountDownAnimation,
    isSoundOn,
    volume,
    setVolume,
    streamerUsername,   // <-- add this
    winnerUsername      // <-- add this
}) => {
    return (
        <div className="but-group">
            <WinnerSelection openAnimation={openAnimation} isSoundOn={isSoundOn} volume={volume} setVolume={setVolume}/>
            <StartCountdown openCountDownAnimation={openCountDownAnimation} isSoundOn={isSoundOn} volume={volume} setVolume={setVolume}/>
            <TweetPromote
                isSoundOn={isSoundOn}
                volume={volume}
                setVolume={setVolume}
                streamerUsername={streamerUsername}
                winnerUsername={winnerUsername}
            />
        </div>
    );
};

export default ButtonGroup;
